import { render } from "./RoofPriceBanner.vue?vue&type=template&id=032568b6&scoped=true"
import script from "./RoofPriceBanner.vue?vue&type=script&lang=js"
export * from "./RoofPriceBanner.vue?vue&type=script&lang=js"

import "./RoofPriceBanner.vue?vue&type=style&index=0&id=032568b6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-032568b6"]])

export default __exports__